import { createTheme } from '@mui/material/styles';

export const mk_theme = createTheme({
  palette: {
    primary: {
      light: '#a6a6a6',
      main: '#000000',
      dark: '#424242',
      contrastText: '#fff',
    },
    secondary: {
      light: '#b1b1b1',
      main: '#9e9e9e',
      dark: '#6e6e6e',
      contrastText: '#000',
    },
    tertiary: {
      main: '#fafafa',
    },
  },
});
